import { useState } from "react";
import { Conference } from "@scrile/api-provider/dist/projects/webvideo/ConferenceProvider";
import providers from "lib/providers";

export default function useConference() {
  const [showConferenceModal, setShowConferenceModal] = useState(false);
  const [conference, setConference] = useState<Conference | null>(null);

  const createConference = async () => {
    const result = await providers.ConferenceProvider.create();
    setConference(result);
  };

  return {
    showConferenceModal,
    conference,
    setShowConferenceModal,
    createConference,
  };
}
